import classes from './EmploymentCalendarPage.module.scss';

const EmploymentCalendarPage = () => {
	return <section className={classes.mainContainer}>EMPLOYMENT</section>;
};

export default EmploymentCalendarPage;
